import { render, staticRenderFns } from "./DeleteModalForm.vue?vue&type=template&id=436de48c&scoped=true&"
import script from "./DeleteModalForm.vue?vue&type=script&lang=ts&"
export * from "./DeleteModalForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteModalForm.vue?vue&type=style&index=0&id=436de48c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436de48c",
  null
  
)

export default component.exports